import Vuex from 'vuex';
import Vue from 'vue';

import settings from './modules/settings/index';
import authentication from './modules/auth/index';
import actions from './modules/actions/index';
import treatments from './modules/treatments/index';
import templates from './modules/templates/index';
import alertRules from './modules/settings/alert-rules/index';
import research from './modules/research/index';
import companies from './modules/companies/index';
import charts from './modules/charts/index';
import master from './modules/master/index';
import invites from './modules/invites/index';
import trash from './modules/trash/index';
import answers from './modules/answers/index';
import clients from './modules/clients/index';
import calendar from './modules/calendar/index';
import submit from './modules/submit/index';
import bulletins from './modules/bulletins/index';
import dashboard from './modules/dashboard/index';
import branches from './modules/branches/index';
import profiles from './modules/profiles/index';
import users from './modules/users/index';
import indicators from './modules/indicators/index';
import integrations from './modules/integrations/index';
import zenvia from './modules/integrations/zenvia/index';
import closetheloop from './modules/closetheloop/index';
import panels from './modules/panels/index';

Vue.use(Vuex);

const modules = {
  settings,
  authentication,
  actions,
  treatments,
  templates,
  alertRules,
  research,
  companies,
  charts,
  master,
  invites,
  trash,
  answers,
  clients,
  calendar,
  submit,
  bulletins,
  dashboard,
  branches,
  profiles,
  integrations,
  users,
  indicators,
  zenvia,
  closetheloop,
  panels,
};

export default new Vuex.Store({
  modules,
});



// WEBPACK FOOTER //
// ./src/store/index.js